import { setMyAIConsent } from "../../api/user/setMyAIConsent";
import { CRMAppLocationIdentifier, FaqProps } from "../../types/Faq";
import AIDisclaimer from "../AIDisclaimer";
import APModal from "../APModal";
import APButton from "../buttons/APButton";
import InfoButton from "../buttons/InfoButton";

interface AIDisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  faqProps?: FaqProps;
  faqLocationIdentifier?: CRMAppLocationIdentifier;
}

const AIDisclaimerModal = ({
  isOpen,
  onClose,
  onConfirm,
  faqProps,
  faqLocationIdentifier,
}: AIDisclaimerModalProps) => {
  const { mutateAsync: mutateSetAIConsentAsync } = setMyAIConsent();

  const onAIConsentAccepted = async () => {
    mutateSetAIConsentAsync();
    onConfirm();
  };

  const infoButton =
    faqLocationIdentifier && faqProps ? (
      faqProps.renderAppLocation(
        faqLocationIdentifier,
        <InfoButton />,
        true,
        true
      )
    ) : (
      <InfoButton />
    );

  return (
    <APModal
      isOpen={isOpen}
      onClose={onClose}
      closeText="Back"
      confirmButton={
        <APButton
          variant="contained"
          text="Yes"
          onClick={onAIConsentAccepted}
        />
      }
    >
      <AIDisclaimer titleAdornment={infoButton} />
    </APModal>
  );
};

export default AIDisclaimerModal;
